import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/country/countryAction";
// import { CustomerEditDialogHeader } from "./CustomerEditDialogHeader";
import { CountryCreateForm } from "./CountryCreateForm";
import { useCountryUIContext } from "../CountryUIContext";
 
export function CountryCreateDialog({ id, show, onHide }) {
 
  // Customers UI Context
  const countryUIContext = useCountryUIContext();
  const countryUIProps = useMemo(() => {
    return {
      initCustomer: countryUIContext.initCountry,
    };
  }, [countryUIContext]);

  // Customers Redux state
  const dispatch = useDispatch();
  const { actionsLoading, customerForEdit,customerForArea,data} = useSelector(
    (state) => ({
      actionsLoading: state.customers.actionsLoading,
      customerForEdit: state.customers.customerForEdit,
      customerForArea: state.customers.customerForArea,
      data:state.customers.entities,

    }),
    shallowEqual
  );
  useEffect(() => {
    dispatch(actions.listCountry());

  }, [id, dispatch]);
  // server request for saving customer
  const saveCountry = (country) => {
     console.log('i am called ',country);
    if (!id) {
      // server request for creating customer
      dispatch(actions.createCountry(country)).then(() => onHide());
      
     }
    //   else {
    //   // server request for updating customer
    //   dispatch(actions.updateCustomer(customer)).then(() => onHide());
    // }
  };

  return (
    <Modal
      size="lg"
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {/* <CustomerEditDialogHeader id={id} /> */}
      <CountryCreateForm
        saveCountry={saveCountry}
        actionsLoading={actionsLoading}
        country={customerForEdit || countryUIProps.initCustomer}
        onHide={onHide}
        areas={customerForArea}
        countries={data}

      />
    </Modal>
  );
}
